import React, { Component } from 'react'
import ShopItem from './ShopItem'
import '../styles/Carousel.css'
import '../styles/Page.css'
import '../styles/Footer.css'

class Men extends Component {

    state ={
        layerImg: "../images/men-layer.jpg",
        shopItem: [
            {
                id: 'black-men-heart',
                img1: '/images/black-men-heart-front.png', 
                img2: '/images/black-men-heart-side.png', 
                idImg1: 'black-men-heart-front', 
                idImg2: 'black-men-heart-side',
                alt: 'Black Tee', 
                title: 'Black Tee', 
                price: 19.00
            },
            {
                id: 'white-men-heart',
                img1: '/images/white-men-heart-front.png', 
                img2: '/images/white-men-heart-side.png', 
                idImg1: 'white-men-heart-front', 
                idImg2: 'white-men-heart-side',
                alt: 'White Tee', 
                title: 'White Tee', 
                price: 19.00
            },
            {
                id: 'white-men-umbrella',
                img1: '/images/white-men-umbrella-front.png', 
                img2: '/images/white-men-umbrella-side.png', 
                idImg1: 'white-men-umbrella-front', 
                idImg2: 'white-men-umbrella-side',
                alt: 'White Tee', 
                title: 'White Tee', 
                price: 19.00
            },
            {
                id: 'black-men-umbrella',
                img1: '/images/black-men-umbrella-front.png', 
                img2: '/images/black-men-umbrella-side.png', 
                idImg1: 'black-men-chest-front', 
                idImg2: 'black-men-chest-side',
                alt: 'Black Tee', 
                title: 'Black Tee', 
                price: 19.00
            },
            {
                id: 'purple-men-chest',
                img1: '/images/purple-men-chest-front.png', 
                img2: '/images/purple-men-chest-side.png', 
                idImg1: 'purple-men-chest-front', 
                idImg2: 'purple-men-chest-side',
                alt: 'Purple Tee', 
                title: 'Purple Tee', 
                price: 19.00
            },
            {
                id: 'white-men-chest',
                img1: '/images/white-men-chest-front.png', 
                img2: '/images/white-men-chest-side.png', 
                idImg1: 'white-men-chest-front', 
                idImg2: 'white-men-chest-side',
                alt: 'White Tee', 
                title: 'White Tee', 
                price: 19.00
            },
        ]
    }
    
    render() {
        return (
            <div className="page">
                <div className="layer" style={{backgroundImage: `url(${this.state.layerImg})`}}></div>
                <div className="container text-center">
                    <div className="shop">
                        {
                            this.state.shopItem.map((item, index)=>{
                                return(
                                    <ShopItem 
                                        key={index} 
                                        id={item.id}
                                        img1={item.img1} 
                                        img2={item.img2} 
                                        idImg1={item.idImg1} 
                                        idImg2={item.idImg2} 
                                        alt={item.alt} 
                                        title={item.title} 
                                        price={item.price} 
                                        color={item.color}
                                        scrollToTop={this.props.scrollToTop}
                                    />
                                )
                            })
                        }
                    </div>
                </div>
            </div>
            
        )
    }
}

export default Men
